const PATH = 'fe.components.measure.view.examples_and_notes.classroom_examples';

const messages = {
  currentSelection: {
    key: `${PATH}.current_selection`,
    defaultValue: 'Current Selection:'
  },
  header: {
    key: `${PATH}.header`,
    defaultValue: 'Observation Feedback'
  },
  strengthExample: {
    key: `${PATH}.strength_example`,
    defaultValue: 'Strength Example'
  },
  strengthExampleDesc: {
    key: `${PATH}.strength_example_desc`,
    defaultValue:
      'Select a dimension or indicator to highlight as an effective practice.'
  },
  strengthExampleDescFormal: {
    key: `${PATH}.strength_example_desc_formal`,
    defaultValue:
      'Select a dimension or indicator to highlight as an effective practice. You can use the suggested dimension and indicator, or select your own.'
  },
  growth: {
    key: `${PATH}.growth`,
    defaultValue: 'Growth'
  },
  growthExample: {
    key: `${PATH}.growth_example`,
    defaultValue: 'Area of Growth Example'
  },
  growthExampleDesc: {
    key: `${PATH}.growth_example_desc`,
    defaultValue:
      'Select a dimension or indicator to highlight as an area for growth.'
  },
  growthExampleDescFormal: {
    key: `${PATH}.growth_example_desc_formal`,
    defaultValue:
      'Select a dimension or indicator to highlight as an area for growth. You can use the suggested dimension and indicator, or select your own.'
  },
  dimension: {
    key: `${PATH}.dimension`,
    defaultValue: 'Dimension'
  },
  dimensionPlaceholder: {
    key: `${PATH}.dimension_placeholder`,
    defaultValue: 'Select a dimension'
  },
  indicator: {
    key: `${PATH}.indicator`,
    defaultValue: 'Indicator'
  },
  indicatorPlaceholder: {
    key: `${PATH}.indicator_placeholder`,
    defaultValue: 'Select an indicator'
  },
  suggested: {
    key: `${PATH}.suggested`,
    defaultValue: '(Suggested)'
  },
  textPlaceholder: {
    key: `${PATH}.text_placeholder`,
    defaultValue: 'Enter an example from your observation.'
  },
  scoresChangedTitle: {
    key: `${PATH}.scores_changed_title`,
    defaultValue: "The observation's scores changed"
  },
  scoresChangedConfirmation: {
    key: `${PATH}.scores_changed_confirmation`,
    defaultValue: 'Yes, I will review'
  },
  scoresChangedContent: {
    key: `${PATH}.scores_changed_content`,
    defaultValue:
      "The observation's scores changed. Please review your Strengths and Growths example before continuing."
  },
  strength: {
    key: `${PATH}.strength`,
    defaultValue: 'Strength'
  },
  errors: {
    missingCyclesInformation: {
      key: `${PATH}.errors.missing_cycles`,
      defaultValue:
        'All cycle scores must be completed before entering Area of Strength and Area for Growth'
    }
  }
};

export default messages;
